import React, { Fragment, useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import "./FraFees.css";
import Loading from "../Loading/Loading";

const FraFees = () => {
    const [loading, setLoading] = useState(true);

    const fraFeesData = [
        {
            title: "FEES APPROVED AY 2026-27",
            pdf: "/FRAFEES/FEES APPROVED AY 2026-27.pdf",
        },
        {
            title: "COMPUTATION SHEET OF FRA 2026-27",
            pdf: "/FRAFEES/COMPUTATION SHEET OF FRA 2026-27.pdf",
        },
        {
            title: "FEES APPROVED AY 2025-26",
            pdf: "/FRAFEES/FRA Document B44.pdf",
        },
        {
            title: "FRA DISCLOSURE YEAR-WISE",
            pdf: "/FRAFEES/FRA Disclosure Year-wise.pdf",
        },
    ];

    useEffect(() => {
        // simulate loading delay (preloader)
        const timer = setTimeout(() => {
            setLoading(false);
        }, 800); // adjust time if needed

        return () => clearTimeout(timer);
    }, []);

    return (
        <Fragment>
            {loading && <Loading />}

            {!loading && (
                <div className="nirf-page-container container">
                    <div className="nirf-page-table-container">
                        <table className="nirf-page-table">
                            <tbody>
                                {fraFeesData.map((item, index) => (
                                    <tr key={index}>
                                        <td>{index + 1}.</td>
                                        <td>{item.title}</td>
                                        <td className="nirf-page-pdf">
                                            <a
                                                href={item.pdf}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <FaEye className="nirf-page-pdf-view" />
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}
        </Fragment>
    );
};

export default FraFees;
